export default __webpack_public_path__ + "static/media/thrive.6372ad30.jpg";